import { getApiBaseUrl } from '../config/env';

const BASE_URL = getApiBaseUrl();

async function parseError(res) {
  let message = `Request failed (${res.status})`;
  try {
    const body = await res.json();
    message = body.message || body.error || message;
  } catch {
    /* ignore */
  }
  const err = new Error(message);
  err.status = res.status;
  return err;
}

export async function recruiterLogin({ email, password }) {
  const res = await fetch(`${BASE_URL}/api/auth/recruiter/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  if (!res.ok) throw await parseError(res);
  return res.json();
}

export async function recruiterRegister({ name, email, company, password }) {
  const res = await fetch(`${BASE_URL}/api/auth/recruiter/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, email, company, password }),
  });
  if (!res.ok) throw await parseError(res);
  return res.json();
}
